import React, { useLayoutEffect, useRef } from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Pricing } from './pages/Pricing';
import { AdditionalCosts } from './pages/AdditionalCosts';
import { Contact } from './pages/Contact';
import { Industries } from './pages/Industries';
import { Crm } from './pages/Crm';
import { useHashRoute, type Route } from './hooks/useHashRoute';
import { trackPageView } from './utils/tracking';
const pageTitles: Record<Route, string> = {
  home: 'Ad ROI Marketing | Marketing & Conversions',
  pricing: 'Pricing & Plans | Ad ROI Marketing',
  additionalCosts: 'Additional Costs & Usage Rates | Ad ROI Marketing',
  contact: 'Contact Us | Ad ROI Marketing',
  industries: 'Industries We Serve | Ad ROI Marketing',
  crm: '1Dash.Pro CRM | Ad ROI Marketing'
};
export function App() {
  const route = useHashRoute();
  const firstView = useRef(true);
  useLayoutEffect(() => {
    document.title = pageTitles[route];
    // Initial load is tracked here; later hash changes are tracked by the global listener.
    if (firstView.current) {
      firstView.current = false;
      trackPageView();
    }
  }, [route]);
  return <div className="min-h-screen w-full bg-white font-sans text-gray-900 selection:bg-red-200 selection:text-red-900" data-id="element-0" data-mp="5otf64sd496">
      <AnnouncementBar data-id="element-1" data-mp="2zlv6yuqqp1v2" />
      <Navbar route={route} data-id="element-2" data-mp="2zmem63p09c5e" />
      <main data-id="element-3" data-mp="2zng1ikd20ksx">
        {route === 'pricing' && <Pricing data-id="element-4" data-mp="33m5e4aq9pybi" />}
        {route === 'additionalCosts' && <AdditionalCosts data-id="element-5" data-mp="33oriy2lrxzq1" />}
        {route === 'contact' && <Contact data-id="element-6" data-mp="38li7lebna3n2" />}
        {route === 'industries' && <Industries data-id="element-7" data-mp="38nuodo5o27yj" />}
        {route === 'crm' && <Crm data-id="element-8" data-mp="3dle3sre3oqs2" />}
        {route === 'home' && <Home data-id="element-9" data-mp="3dmfo7mh0apmg" />}
      </main>
      <Footer data-id="element-10" data-mp="3dii5h1ycc033" />
    </div>;
}